module.exports = __webpack_public_path__ + "static/img/extend_img06.f63a1ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/extend_img06.png
// module id = wUZb
// module chunks = 1